import { type ViewOrder, type ViewSurface } from '@terros/common'
import { useUpdatePreference } from '../preferences/update'
import { type UpdateHookResponse } from '../hooks'
import { getViewOrderPreference } from './orderPreference'
import { useViewCache } from './cache'

export function useUpdateViewOrder(surface: ViewSurface): UpdateHookResponse<ViewOrder> {
  const preference = getViewOrderPreference(surface)
  const mutation = useUpdatePreference(preference)
  const cache = useViewCache()

  async function update(order: ViewOrder): Promise<ViewOrder> {
    const saved = (await mutation.update(order)) ?? order
    await cache.order(surface, saved)
    return saved
  }

  return { ...mutation, update }
}
